import { MESApiService, getMomentTz, spParameter } from "@dexteel/mesf-core";

const moment = getMomentTz();

export const getNearbyHeats = async (heatName: string) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "HeatName", value: heatName }];
  return await apiService.callV2("[LAB].[GetNearbyHeats]", parameters);
};

export const updateChemistrySample = async (
  chemistrySampleId: number,
  heatName: string | null,
  gradeId: number | null,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ChemistrySampleId", value: chemistrySampleId },
    { name: "HeatName", value: heatName },
    { name: "GradeId", value: gradeId },
  ];
  return await apiService.callV2("[LAB].[UpdateChemistrySample]", parameters);
};

export const getChemistriesByDateRange = async (
  startDate: Date,
  endDate: Date,
  sampleTypeId: number,
  gradeId: number,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters = [
    { name: "StartDate", value: startDate.toISOString() },
    { name: "EndDate", value: endDate.toISOString() },
    { name: "SampleId", value: sampleTypeId },
    { name: "GradeId", value: gradeId },
  ];
  const resp = await apiService.callV2(
    "[LAB].[GetReportChemistrySamples]",
    parameters,
    signal,
  );

  if (resp.ok) {
    const rows = resp.data?.tables?.[0]?.rows ?? [];
    for (const row of rows) {
      row.Reception = row.Reception ? moment.utc(row.Reception).toDate() : null;
      row.Reported = row.Reported ? moment.utc(row.Reported).toDate() : null;
    }
  }

  return resp;
};
